/* registerIcons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("branding.control", require("./rawicons/branding/control.icon.svg.js"));
IconRegistry.registerIcon(
    "branding.lanSwitching",
    require("./rawicons/branding/lanSwitching.icon.svg.js")
);
IconRegistry.registerIcon(
    "branding.osUpgrade",
    require("./rawicons/branding/osUpgrade.icon.svg.js")
);
IconRegistry.registerIcon("branding.qos", require("./rawicons/branding/qos.icon.svg.js"));
IconRegistry.registerIcon("branding.routing", require("./rawicons/branding/routing.icon.svg.js"));
IconRegistry.registerIcon("branding.sdwan", require("./rawicons/branding/sdwan.icon.svg.js"));
IconRegistry.registerIcon(
    "branding.solutionsManagement",
    require("./rawicons/branding/solutionsManagement.icon.svg.js")
);
IconRegistry.registerIcon(
    "branding.systemSettings",
    require("./rawicons/branding/systemSettings.icon.svg.js")
);
IconRegistry.registerIcon("branding.vlan", require("./rawicons/branding/vlan.icon.svg.js"));
IconRegistry.registerIcon("common.arrow", require("./rawicons/common/arrow.icon.svg.js"));
IconRegistry.registerIcon("common.avatar", require("./rawicons/common/avatar.icon.svg.js"));
IconRegistry.registerIcon("common.bomb", require("./rawicons/common/bomb.icon.svg.js"));
IconRegistry.registerIcon("common.back", require("./rawicons/common/back.icon.svg.js"));
IconRegistry.registerIcon("common.check", require("./rawicons/common/check.icon.svg.js"));
IconRegistry.registerIcon("common.chevron", require("./rawicons/common/chevron.icon.svg.js"));
IconRegistry.registerIcon("common.close", require("./rawicons/common/close.icon.svg.js"));
IconRegistry.registerIcon("common.duck", require("./rawicons/common/duck.icon.svg.js"));
IconRegistry.registerIcon("common.duplicate", require("./rawicons/common/duplicate.icon.svg.js"));
IconRegistry.registerIcon("common.edit", require("./rawicons/common/edit.icon.svg.js"));
IconRegistry.registerIcon("common.error", require("./rawicons/common/error.icon.svg.js"));
IconRegistry.registerIcon("common.file", require("./rawicons/common/file.icon.svg.js"));
IconRegistry.registerIcon("common.filter", require("./rawicons/common/filter.icon.svg.js"));
IconRegistry.registerIcon("common.folder", require("./rawicons/common/folder.icon.svg.js"));
IconRegistry.registerIcon("common.ghost", require("./rawicons/common/ghost.icon.svg.js"));
IconRegistry.registerIcon("common.grid", require("./rawicons/common/grid.icon.svg.js"));
IconRegistry.registerIcon("common.info", require("./rawicons/common/info.icon.svg.js"));
IconRegistry.registerIcon("common.loading", require("./rawicons/common/loading.icon.svg.js"));
IconRegistry.registerIcon("common.lock", require("./rawicons/common/lock.icon.svg.js"));
IconRegistry.registerIcon("common.maximize", require("./rawicons/common/maximize.icon.svg.js"));
IconRegistry.registerIcon("common.minimize", require("./rawicons/common/minimize.icon.svg.js"));
IconRegistry.registerIcon("common.poo", require("./rawicons/common/poo.icon.svg.js"));
IconRegistry.registerIcon("common.skull", require("./rawicons/common/skull.icon.svg.js"));
IconRegistry.registerIcon("common.star", require("./rawicons/common/star.icon.svg.js"));
IconRegistry.registerIcon("common.success", require("./rawicons/common/success.icon.svg.js"));
IconRegistry.registerIcon("common.trash_bin", require("./rawicons/common/trash_bin.icon.svg.js"));
IconRegistry.registerIcon("common.unknown", require("./rawicons/common/unknown.icon.svg.js"));
IconRegistry.registerIcon("common.failed", require("./rawicons/common/failed.icon.svg.js"));
IconRegistry.registerIcon("common.paused", require("./rawicons/common/paused.icon.svg.js"));
IconRegistry.registerIcon("common.pending", require("./rawicons/common/pending.icon.svg.js"));
IconRegistry.registerIcon("common.staropen", require("./rawicons/common/staropen.icon.svg.js"));
IconRegistry.registerIcon("common.multi_edit", require("./rawicons/common/multi_edit.icon.svg"));
IconRegistry.registerIcon(
    "common.single_edit",
    require("./rawicons/common/single_edit.icon.svg.js")
);
IconRegistry.registerIcon("toggle.lock", require("./rawicons/toggle/lock.icon.svg.js"));
IconRegistry.registerIcon("toggle.lockunlock", require("./rawicons/toggle/lockunlock.icon.svg.js"));
IconRegistry.registerIcon("toggle.open", require("./rawicons/toggle/open.icon.svg.js"));
IconRegistry.registerIcon("toggle.pin", require("./rawicons/toggle/pin.icon.svg.js"));
IconRegistry.registerIcon("toggle.poostar", require("./rawicons/toggle/poostar.icon.svg.js"));
IconRegistry.registerIcon("toggle.skullbomb", require("./rawicons/toggle/skullbomb.icon.svg.js"));
IconRegistry.registerIcon("toggle.sort", require("./rawicons/toggle/sort.icon.svg.js"));
IconRegistry.registerIcon(
    "devicemanager.restore",
    require("./rawicons/common/restore.icon.svg.js")
);
IconRegistry.registerIcon("common.backup", require("./rawicons/common/backup.icon.svg.js"));
IconRegistry.registerIcon(
    "common.linkandsync",
    require("./rawicons/common/linkandsync.icon.svg.js")
);
IconRegistry.registerIcon(
    "configdrift.compare_compact",
    require("./rawicons/common/compare_compact_icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.compare_expanded",
    require("./rawicons/common/compare_expanded_icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.compare_side_by_side",
    require("./rawicons/common/compare_side_by_side_icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.compare_line_by_line",
    require("./rawicons/common/compare_line_by_line_icon.svg")
);

IconRegistry.registerIcon("common.code", require("./rawicons/common/code.icon.svg.js"));
